import ReCAPTCHA from 'react-google-recaptcha'

export default function ReCaptcha({ innerRef, onChange }) {
	if (!process.env.REACT_APP_RECAPTCHA_KEY || true) return null // disable recaptcha on dev
	return (
		<ReCAPTCHA ref={innerRef} size="invisible" sitekey={process.env.REACT_APP_RECAPTCHA_KEY} onChange={onChange} />
	)
}
